/* Custom SVG tier icons for LEOR Radiance Rewards - Royal & Classy */

export const BloomIcon = ({ size = 48, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* Delicate petal/bloom - rose gold tones */}
    <defs>
      <linearGradient id="bloom-grad" x1="16" y1="8" x2="48" y2="56" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#E8C4B0" />
        <stop offset="50%" stopColor="#D4A089" />
        <stop offset="100%" stopColor="#C08870" />
      </linearGradient>
      <linearGradient id="bloom-inner" x1="24" y1="16" x2="40" y2="48" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#F0D5C4" />
        <stop offset="100%" stopColor="#D4A089" />
      </linearGradient>
    </defs>
    {/* Main petal */}
    <path d="M32 8C26 8 18 16 18 28C18 36 22 44 32 56C42 44 46 36 46 28C46 16 38 8 32 8Z" stroke="url(#bloom-grad)" strokeWidth="1.5" fill="none" />
    {/* Inner vein */}
    <path d="M32 16V44" stroke="url(#bloom-inner)" strokeWidth="0.8" opacity="0.6" />
    {/* Side veins */}
    <path d="M32 24L24 30" stroke="url(#bloom-inner)" strokeWidth="0.5" opacity="0.4" />
    <path d="M32 24L40 30" stroke="url(#bloom-inner)" strokeWidth="0.5" opacity="0.4" />
    <path d="M32 32L26 36" stroke="url(#bloom-inner)" strokeWidth="0.5" opacity="0.4" />
    <path d="M32 32L38 36" stroke="url(#bloom-inner)" strokeWidth="0.5" opacity="0.4" />
    {/* Small dot at top */}
    <circle cx="32" cy="12" r="1.5" fill="url(#bloom-grad)" opacity="0.8" />
  </svg>
);

export const LustreIcon = ({ size = 48, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* 4-point star sparkle - golden */}
    <defs>
      <linearGradient id="lustre-grad" x1="8" y1="8" x2="56" y2="56" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#D4AD4A" />
        <stop offset="50%" stopColor="#C5961B" />
        <stop offset="100%" stopColor="#A67C17" />
      </linearGradient>
      <radialGradient id="lustre-glow" cx="32" cy="32" r="20" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#D4AD4A" stopOpacity="0.3" />
        <stop offset="100%" stopColor="#D4AD4A" stopOpacity="0" />
      </radialGradient>
    </defs>
    {/* Glow */}
    <circle cx="32" cy="32" r="20" fill="url(#lustre-glow)" />
    {/* Main 4-point star */}
    <path d="M32 6L35 26L56 32L35 38L32 58L29 38L8 32L29 26Z" stroke="url(#lustre-grad)" strokeWidth="1.2" fill="none" />
    {/* Inner star */}
    <path d="M32 18L33.5 29L44 32L33.5 35L32 46L30.5 35L20 32L30.5 29Z" fill="url(#lustre-grad)" opacity="0.3" />
    {/* Small accent stars */}
    <path d="M48 14L49 17L52 18L49 19L48 22L47 19L44 18L47 17Z" fill="url(#lustre-grad)" opacity="0.5" />
    <path d="M16 44L17 46.5L19.5 47.5L17 48.5L16 51L15 48.5L12.5 47.5L15 46.5Z" fill="url(#lustre-grad)" opacity="0.4" />
  </svg>
);

export const AuraIcon = ({ size = 48, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* Radiant halo/aura ring - warm amber */}
    <defs>
      <linearGradient id="aura-grad" x1="8" y1="16" x2="56" y2="48" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#C5961B" />
        <stop offset="50%" stopColor="#B8860B" />
        <stop offset="100%" stopColor="#8B7A72" />
      </linearGradient>
      <radialGradient id="aura-glow" cx="32" cy="32" r="24" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#C5961B" stopOpacity="0.2" />
        <stop offset="60%" stopColor="#C5961B" stopOpacity="0.08" />
        <stop offset="100%" stopColor="#C5961B" stopOpacity="0" />
      </radialGradient>
    </defs>
    {/* Outer glow */}
    <circle cx="32" cy="32" r="24" fill="url(#aura-glow)" />
    {/* Outer ring */}
    <circle cx="32" cy="32" r="22" stroke="url(#aura-grad)" strokeWidth="1" opacity="0.4" />
    {/* Main ring */}
    <circle cx="32" cy="32" r="16" stroke="url(#aura-grad)" strokeWidth="1.5" />
    {/* Inner ring */}
    <circle cx="32" cy="32" r="10" stroke="url(#aura-grad)" strokeWidth="0.8" opacity="0.5" />
    {/* Center diamond */}
    <path d="M32 24L38 32L32 40L26 32Z" stroke="url(#aura-grad)" strokeWidth="1" fill="url(#aura-grad)" fillOpacity="0.15" />
    {/* Rays */}
    <line x1="32" y1="6" x2="32" y2="12" stroke="url(#aura-grad)" strokeWidth="0.8" opacity="0.4" />
    <line x1="32" y1="52" x2="32" y2="58" stroke="url(#aura-grad)" strokeWidth="0.8" opacity="0.4" />
    <line x1="6" y1="32" x2="12" y2="32" stroke="url(#aura-grad)" strokeWidth="0.8" opacity="0.4" />
    <line x1="52" y1="32" x2="58" y2="32" stroke="url(#aura-grad)" strokeWidth="0.8" opacity="0.4" />
  </svg>
);

export const LuminaryIcon = ({ size = 48, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* Royal crown - deep gold */}
    <defs>
      <linearGradient id="lum-grad" x1="12" y1="16" x2="52" y2="48" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#D4AD4A" />
        <stop offset="40%" stopColor="#C5961B" />
        <stop offset="100%" stopColor="#8B6914" />
      </linearGradient>
      <linearGradient id="lum-gem" x1="28" y1="28" x2="36" y2="36" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#E8D5B0" />
        <stop offset="100%" stopColor="#C5961B" />
      </linearGradient>
    </defs>
    {/* Crown base */}
    <path d="M14 42L16 26L24 34L32 18L40 34L48 26L50 42Z" stroke="url(#lum-grad)" strokeWidth="1.5" fill="none" strokeLinejoin="round" />
    {/* Crown band */}
    <rect x="14" y="42" width="36" height="6" rx="1" stroke="url(#lum-grad)" strokeWidth="1.2" fill="url(#lum-grad)" fillOpacity="0.1" />
    {/* Gems on crown points */}
    <circle cx="32" cy="18" r="2.5" fill="url(#lum-gem)" opacity="0.8" />
    <circle cx="24" cy="32" r="1.5" fill="url(#lum-gem)" opacity="0.6" />
    <circle cx="40" cy="32" r="1.5" fill="url(#lum-gem)" opacity="0.6" />
    {/* Band detail */}
    <circle cx="26" cy="45" r="1" fill="url(#lum-gem)" opacity="0.5" />
    <circle cx="32" cy="45" r="1.2" fill="url(#lum-gem)" opacity="0.6" />
    <circle cx="38" cy="45" r="1" fill="url(#lum-gem)" opacity="0.5" />
    {/* Small stars */}
    <path d="M16 14L16.5 15.5L18 16L16.5 16.5L16 18L15.5 16.5L14 16L15.5 15.5Z" fill="url(#lum-grad)" opacity="0.4" />
    <path d="M48 14L48.5 15.5L50 16L48.5 16.5L48 18L47.5 16.5L46 16L47.5 15.5Z" fill="url(#lum-grad)" opacity="0.4" />
  </svg>
);

export const LeorGlowIcon = ({ size = 48, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* Diamond/gem - platinum with gold reflections */}
    <defs>
      <linearGradient id="glow-grad" x1="16" y1="12" x2="48" y2="52" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#E8E0D4" />
        <stop offset="30%" stopColor="#D4AD4A" />
        <stop offset="70%" stopColor="#C5961B" />
        <stop offset="100%" stopColor="#8B6914" />
      </linearGradient>
      <linearGradient id="glow-facet" x1="24" y1="16" x2="40" y2="40" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#F5EDE0" stopOpacity="0.4" />
        <stop offset="100%" stopColor="#D4AD4A" stopOpacity="0.1" />
      </linearGradient>
      <radialGradient id="glow-radial" cx="32" cy="28" r="24" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#D4AD4A" stopOpacity="0.25" />
        <stop offset="100%" stopColor="#D4AD4A" stopOpacity="0" />
      </radialGradient>
    </defs>
    {/* Radial glow */}
    <circle cx="32" cy="32" r="28" fill="url(#glow-radial)" />
    {/* Diamond shape - top */}
    <path d="M32 8L48 26L32 56L16 26Z" stroke="url(#glow-grad)" strokeWidth="1.5" fill="none" />
    {/* Crown facets */}
    <path d="M16 26L32 8L48 26" stroke="url(#glow-grad)" strokeWidth="1" fill="url(#glow-facet)" />
    {/* Pavilion center line */}
    <line x1="16" y1="26" x2="48" y2="26" stroke="url(#glow-grad)" strokeWidth="1" opacity="0.7" />
    {/* Internal facets */}
    <path d="M24 26L32 8L40 26" stroke="url(#glow-grad)" strokeWidth="0.6" opacity="0.4" />
    <path d="M32 56L24 26" stroke="url(#glow-grad)" strokeWidth="0.6" opacity="0.3" />
    <path d="M32 56L40 26" stroke="url(#glow-grad)" strokeWidth="0.6" opacity="0.3" />
    <path d="M32 56L20 26" stroke="url(#glow-grad)" strokeWidth="0.4" opacity="0.2" />
    <path d="M32 56L44 26" stroke="url(#glow-grad)" strokeWidth="0.4" opacity="0.2" />
    {/* Sparkle accents */}
    <path d="M10 16L10.8 18.2L13 19L10.8 19.8L10 22L9.2 19.8L7 19L9.2 18.2Z" fill="url(#glow-grad)" opacity="0.5" />
    <path d="M54 12L54.6 13.6L56.2 14.2L54.6 14.8L54 16.4L53.4 14.8L51.8 14.2L53.4 13.6Z" fill="url(#glow-grad)" opacity="0.4" />
    <path d="M52 40L52.5 41.5L54 42L52.5 42.5L52 44L51.5 42.5L50 42L51.5 41.5Z" fill="url(#glow-grad)" opacity="0.3" />
  </svg>
);

export const TierIcons = {
  bloom: BloomIcon,
  lustre: LustreIcon,
  aura: AuraIcon,
  luminary: LuminaryIcon,
  leorglow: LeorGlowIcon,
};
